import React, { useEffect, useMemo, useRef, useState } from 'react';
import LeaderboardItemAfterStage from './LeaderboardItemAfterStage';
import { computeChangedRows, getRowKey, getAfterStageRowValue } from '../../utils/highlightDiff';

const guestTextColors = [
  '#63AA57', '#6EB9E3', '#758AF8', '#8DEACE',
  '#B6F875', '#A2DDEA', '#9988FF', '#BECEF6', '#BCEAA0',
  '#ECA3A3', '#F5FF88', '#F875D3', '#FFBEA2', '#FFE5A2',
];

const createColorMapping = (data) => {
  const colorMapping = {};
  let colorIndex = 0;
  data.forEach((item) => {
    const inGroup = (item.inGroup || item.InGroup || '').trim();
    if (!inGroup || colorMapping[inGroup]) return;
    colorMapping[inGroup] = guestTextColors[colorIndex % guestTextColors.length];
    colorIndex++;
  });
  return colorMapping;
};

const MobileAfterStage = ({ results = [], loading, error, emptyMessage = 'Brak danych' }) => {
  const [highlightedRows, setHighlightedRows] = useState(new Set());
  const prevResultsRef = useRef([]);
  const highlightTimerRef = useRef(null);

  const colorMapping = useMemo(() => createColorMapping(results), [results]);

  useEffect(() => {
    const prev = prevResultsRef.current;
    if (prev.length === 0) {
      prevResultsRef.current = results;
      return;
    }

    const newHighlights = computeChangedRows(prev, results, getRowKey, getAfterStageRowValue);

    if (newHighlights.size > 0) {
      clearTimeout(highlightTimerRef.current);
      setHighlightedRows(newHighlights);
      highlightTimerRef.current = setTimeout(() => setHighlightedRows(new Set()), 1800);
    }

    prevResultsRef.current = results;
  }, [results]);

  useEffect(() => () => clearTimeout(highlightTimerRef.current), []);

  if (loading) return <div className="loading-spinner"></div>;

  if (error) {
    return (
      <div className="notification has-text-centered mt-1">
        <strong>{error}</strong>
      </div>
    );
  }

  if (!results.length) {
    return (
      <div className="notification has-text-centered mt-1">
        <strong>{emptyMessage}</strong>
      </div>
    );
  }

  return (
    <div translate="no">
      <div>
        {results.map((data, index) => (
          <LeaderboardItemAfterStage
            key={getRowKey(data) ?? index}
            data={data}
            colorMapping={colorMapping}
            isHighlighted={highlightedRows.has(getRowKey(data))}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileAfterStage;
